export const SITE = {
    nav: "site-nav",
    navLogo: "nav-logo",
    navHome: "nav-link-home",
    navWho: "nav-link-who",
    navWhat: "nav-link-what",
    navSnapshot: "nav-link-snapshot",
    navBlog: "nav-link-blog",
    navContact: "nav-link-contact",
    navCta: "nav-cta-contact",
    mobileToggle: "mobile-menu-toggle",
    footer: "site-footer",
    footerEmail: "footer-email",
};

export const HOME = {
    heroCta: "home-hero-cta",
    heroSecondary: "home-hero-secondary",
    heroSection: "home-hero",
    marquee: "home-marquee",
    servicesSection: "home-services",
    snapshotPreview: "home-snapshot-preview",
    industriesSection: "home-industries",
    statsSection: "home-stats",
    ctaSection: "home-cta",
    serviceCard: (slug) => `home-service-${slug}`,
    emergentLink: "emergent-link",
};

export const SNAPSHOT = {
    grid: "snapshot-grid",
    filterAll: "snapshot-filter-all",
    filterForex: "snapshot-filter-forex",
    filterCrypto: "snapshot-filter-crypto",
    filterPropFirm: "snapshot-filter-prop",
    filterBranding: "snapshot-filter-branding",
    card: (slug) => `snapshot-card-${slug}`,
};

export const CONTACT = {
    form: "contact-form",
    name: "contact-input-name",
    email: "contact-input-email",
    company: "contact-input-company",
    service: "contact-input-service",
    budget: "contact-input-budget",
    message: "contact-input-message",
    submit: "contact-submit-btn",
    success: "contact-success",
};

export const WHO = {
    section: "who-we-are-section",
    valueCard: (slug) => `who-value-${slug}`,
};

export const WHAT = {
    section: "what-we-do-section",
    serviceItem: (slug) => `what-service-${slug}`,
};

export const BLOG = {
    section: "blog-section",
    grid: "blog-grid",
    card: (slug) => `blog-card-${slug}`,
    article: "blog-article",
    backLink: "blog-back-link",
};
